import '../plugins/openClosePlugin';

// open-close init
export default function initFakeSelect() {
  jQuery('.js-fake-select').openClose({
    activeClass: 'active',
    opener: '.fake-select__opener',
    slider: '.fake-select__drop',
    animSpeed: 400,
    effect: 'none',
    hideOnClickOutside: true,
  });
}
